import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import SkullOff from "../../assets/images/LevelThree/skull-off.svg";
import SkullOn from "../../assets/images/LevelThree/skull-on.svg";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";
import Navbar from "../../components/common/Navbar";
// import CherryPopup from "../../components/CherryPopup";
import "./LevelThree.scss";

const skullsCount = 7;
class LevelThree extends Component {
  state = {
    skulls: new Array(skullsCount).fill(false),
    isComplete: false,
    won: false,
    move: false,
  };
  // componentDidMount() {
  //   setTimeout(() => {
  //     this.props.toggleHint(true);
  //   }, 10000);
  //   this.props.changeLevelName("Deepdish");
  // }
  clickSkull = (i) => {
    // this.props.click.volume = 0.3;
    // this.props.click.currentPosition = 0;
    // this.props.click.play();
    let newSkulls = [...this.state.skulls];
    const leftIndex = i - 1 < 0 ? skullsCount - 1 : i - 1;
    const rightIndex = (i + 1) % skullsCount;
    newSkulls[i] = !newSkulls[i];
    newSkulls[leftIndex] = !newSkulls[leftIndex];
    newSkulls[rightIndex] = !newSkulls[rightIndex];
    this.setState({ skulls: newSkulls }, () => {
      const sum = newSkulls.reduce((acc, i) => (i === true ? acc + 1 : acc), 0);
      if (sum === skullsCount) {
        // this.props.clear.volume = 0.6;
        // this.props.clear.play();
        this.setState({ isComplete: true, won: true,move: true });
      }
    });
  };

  nextLevel = () => {
    // this.props.toggleHint(false);
    // this.props.transition.volume = 0.6;
    // this.props.transition.play();
    // this.props.history.push("/4");
  };

  render() {
    const { skulls, isComplete, move, won } = this.state;
    return [
      move && <LevelComplete levelNum={1} />,
      <Navbar won={won} levelNum={1} />,
      <div className="level-3-container">
        <div className="lvl-three-container">
          {skulls.map((s, i) => (
            <img
              key={i}
              src={Boolean(s) ? SkullOn : SkullOff}
              style={{ filter: !this.props.mode ? "invert(0)" : "invert(1)" }}
              alt="skull"
              onClick={() => this.clickSkull(i)}
            />
          ))}
        </div>
      </div>,
      // ,
      // <CherryPopup
      //   isComplete={isComplete}
      //   nextLevel={this.nextLevel}
      //   mode={this.props.mode}
      //   levelName="Karmatic"
      // />,
    ];
  }
}

export default withRouter(LevelThree);
